import TemLogo from 'assets/images/temlogo.png';
import GreekMarinaLogo from 'assets/images/greekmarinaslogo.png';
// import BFLogo from 'assets/images/bflogo.png';
import BFLogo from 'assets/images/bf-logo.png';
import IGYLogo from 'assets/images/igy_logo.svg';
import STXLogo from 'assets/images/stx_logo.png';

export default {
  TEM: {
    name: 'TransEurope Marinas',
    logo: TemLogo,
    width: '70px'
  },
  GRK: {
    name: 'Greek Marinas Association',
    logo: GreekMarinaLogo,
    width: '70px'
  },
  BFG: {
    name: 'Blue Flag',
    logo: BFLogo,
    width: '50px'
  },
  IGY: {
    name: 'Island Global Yachting',
    logo: IGYLogo,
    width: '50px'
  },
  STX: {
    name: 'Suntex Marinas',
    logo: STXLogo,
    width: '50px'
  }
};
